module.exports = __webpack_public_path__ + "img/pin_transport_orange.f9d1a9b4.svg";